import React, { Component } from 'react'
import Api from '../api/Api'
import ReCAPTCHA from 'react-google-recaptcha'
import Loader from '../components/Loader'

const qs = require('qs')

class Contact extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      errors: {},
      token: undefined
    }

    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onSelectChange = this.onSelectChange.bind(this)
  }

  componentDidMount() {
    this.checkUrl()
    this.toggleVisibility(this._type)
  }

  onSelectChange(e) {
    this.toggleVisibility(e.target)
  }

  onFormSubmit(e) {
    e.preventDefault()

    if (this.state.loading) {
      return
    }

    this.setState(
      {
        loading: true
      },
      () => {
        Api.post('/contact', {
          email: this._email.value,
          type: this._type.options[this._type.selectedIndex].value,
          username: this._username.value,
          url: this._url.value,
          message: this._message.value,
          gtoken: this.state.token
        }).then(res => {
          if (res.data.error) {
            this.setState({ errors: res.data.errors, loading: false })
          } else {
            this.setState({ errors: {}, success: true, loading: false })
          }
        })
      }
    )
  }

  onCaptchaChange(value) {
    this.setState({
      token: value
    })
  }

  checkUrl() {
    const params = qs.parse(window.location.search.substring(1))
    switch (params.type) {
      case 'report':
        this._url.value = params.url || ''
        this._type.value = params.type
        this._message.value = 'I want to report this given content!'
        break
      case 'dmca':
        this._type.value = params.type
        break
      default:
        break
    }
  }

  toggleVisibility(elem) {
    const type = elem.options[elem.selectedIndex].value
    if (type === 'report' || type === 'dmca') {
      document.getElementById('url-group').classList.remove('hidden')
    } else {
      document.getElementById('url-group').classList.add('hidden')
    }
  }

  render() {
    const { errors, loading } = this.state

    if (this.state.success) {
      return (
        <div className="container">
          <h1 className="section-headline">Contact</h1>

          <h4>Your contact was submitted successfully</h4>
        </div>
      )
    }

    return (
      <div className="container">
        {loading && <Loader type="side" />}
        <h1 className="section-headline">Contact</h1>

        <form onSubmit={this.onFormSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-Mail-Address*</label>
            {errors && errors.email && (
              <div className="errors">{errors.email.join(', ')}</div>
            )}
            <input
              type="email"
              name="email"
              className="form-control"
              ref={e => (this._email = e)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="type">Type of contact</label>
            <select
              name="type"
              defaultValue={this.props.type}
              className="form-control"
              onChange={this.onSelectChange}
              ref={e => (this._type = e)}
            >
              <option value="default">Global</option>
              <option value="report">Report</option>
              <option value="advertisement">Advertisement</option>
              <option value="dmca">DMCA</option>
            </select>
          </div>
          <div className="form-group hidden" id="url-group">
            <label htmlFor="url">URL to the content*</label>
            <input
              type="text"
              name="url"
              className="form-control"
              ref={e => (this._url = e)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Your message*</label>
            {errors && errors.message && (
              <div className="errors">{errors.message.join(', ')}</div>
            )}
            <textarea
              className="form-control"
              name="message"
              rows={4}
              ref={e => (this._message = e)}
            />
          </div>

          <input
            type="hidden"
            name="username"
            ref={e => (this._username = e)}
          />

          {errors && errors.captcha && (
            <div className="errors">{errors.captcha.join(', ')}</div>
          )}
          <ReCAPTCHA
            sitekey="6LdvnQATAAAAAJTycvBXcEPhtyOQeo8yJRJAD4vS"
            onChange={this.onCaptchaChange.bind(this)}
            theme="dark"
          />

          <button className="btn btn-default mt-3">Submit</button>
        </form>
      </div>
    )
  }
}

export default Contact
